export enum AddressType {
  Billing = 'billing',
  Shipping = 'shipping',
}

export const SUPER_ADMIN = 'super_admin';
export const STORE_OWNER = 'store_owner';
export const STAFF = 'staff';
export const TOKEN = 'token';
export const ROLES = 'roles';
export const AUTH_CRED = 'AUTH_CRED_SHOP';
export const EMAIL_VERIFIED = 'emailVerified';
export const MAINTENANCE_DETAILS = 'MAINTENANCE_DETAILS';
export const isProduction = process.env.NODE_ENV === 'production';
